import type { IOption } from "@components/ui-kit";
import { appStore } from "@src/stores/AppStore";
import { compact, uniqueId } from "lodash";
import { computed, makeObservable, observable } from "mobx";
import React from "react";
import type { CreditAccountModel } from "../listing/models";
import { FormCreditAccount } from "./FormCreditAccount";

interface BrandOption {
  label: string;
  value: string;
  client_id: number;
}

export class StoreCreditAccountForm {
  @observable.ref form = new FormCreditAccount();
  @observable.ref brandOptions: BrandOption[] = [];
  @observable.ref expenseOptions: IOption[] = [];
  @observable.ref teamOptions: IOption[] = [];
  @observable.ref workOptions: IOption[] = [];

  @observable.ref budgetInputVal = "";

  constructor() {
    makeObservable(this);
  }

  fillCreditAccountForm(creditAccount: CreditAccountModel) {
    this.form.brand_id.onChange(creditAccount.brand.id);
    this.form.team_id.onChange(creditAccount.team.id);
    this.form.title.onChange(creditAccount.title);
    this.form.budget_category_ids.onChange(
      compact([
        ...creditAccount.ourWorkBudgetCategories.map(
          (c) =>
            this.budgetOptions.find(
              (bo) =>
                bo.label ===
                  this.workOptions.find((wo) => wo.value === c.id)?.label || "",
            )?.value || "",
        ),
        ...creditAccount.expenseBudgetCategories.map(
          (c) =>
            this.budgetOptions.find(
              (bo) =>
                bo.label ===
                  this.expenseOptions.find((wo) => wo.value === c.id)?.label ||
                "",
            )?.value || "",
        ),
      ]),
    );
  }

  fillDefaultCreditAccountForm() {
    this.form.budget_category_ids.onChange(
      this.budgetOptions.map((option) => option.value),
    );
    this.form.team_id.onChange(appStore.authStore.user?.team?.id ?? "");
  }

  @computed get budgetOptions() {
    return [
      ...this.expenseOptions.map((e) => ({
        label: e.label,
        value: uniqueId(),
      })),
      ...this.workOptions.map((w) => ({ label: w.label, value: uniqueId() })),
    ];
  }

  @computed get budgetOptionsWithDisabledState() {
    const budgetOptionsWithDisabled: {
      label: string;
      value: string;
      disabled: boolean;
    }[] = [];

    this.budgetOptions.forEach((option) => {
      if (
        this.form.budget_category_ids.value.length === 1 &&
        this.form.budget_category_ids.value.indexOf(option.value) !== -1
      ) {
        budgetOptionsWithDisabled.push({
          ...option,
          disabled: true,
        });
      } else {
        budgetOptionsWithDisabled.push({
          ...option,
          disabled: false,
        });
      }
    });

    return budgetOptionsWithDisabled;
  }

  static create() {
    return new StoreCreditAccountForm();
  }
}

export const FormCreditAccountCtx = React.createContext<StoreCreditAccountForm>(
  null as any as StoreCreditAccountForm,
);
